// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .kore-chat-body .dummy.listTableContainerDiv {
  pointer-events: none;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv {
  background-color: var(--sdk-chat-widow-default-white);
  box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);
  border-radius: 10px;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainerDivRepet {
  width: 100%;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableHeader .listTableHeaderTitle {
  font-size: 16px;
  font-weight: bold;
  color: var(--sdk-chat-widow-primary-font-color);
  width: 100%;
  display: block;
  float: left;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableHeader .listtableHeaderFilters {
  width: 120px;
  display: block;
  float: left;
  text-align: right;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableHeader .listtableHeaderFilters .filterIcon {
  width: 15px;
  cursor: pointer;
  display: inline-block;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableHeader .listtableHeaderFilters .sortingIcon {
  width: 15px;
  cursor: pointer;
  display: inline-block;
  margin-left: 20px;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer {
  padding: 0 15px;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv {
  border-bottom: 1px solid var(--sdk-chat-widow-primary-border-color);
  padding: 15px 0;
  display: inline-block;
  width: 100%;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc .titleActions .listViewItemValue {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv:nth-last-child(1) {
  border-bottom: 0;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails {
  float: left;
  width: 100%;
  vertical-align: top;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsTitle {
  /* margin: 0 0 15px 0; */
  font-size: 14px;
  font-weight: bold;
  color: var(--sdk-chat-widow-primary-font-color);
  width: 58%;
  display: inline-block;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainerDivRepet .listTableDetails .listTableHeader .listTableHeaderDesc {
  display: inline-block;
  vertical-align: top;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc {
  margin: 0 0 15px 0;
  font-size: 14px;
  font-weight: bold;
  padding: 10px;
  color: var(--sdk-chat-widow-primary-font-color);
  border-bottom: 1px solid var(--sdk-chat-window-table-border-color);
  display: table;
  width: 100%;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc.pointerStyle:hover {
  cursor: pointer;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc.largeImg {
  margin-bottom: 10px;
  padding: 10px;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc.mediumImg {
  margin-bottom: 10px;
  padding: 10px;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc.smallImg {
  margin-bottom: 10px;
  padding: 10px;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listViewItemValue.actionLink.actiontitle {
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc:nth-last-child(1) {
  margin-bottom: 0;
  border-bottom: 0;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc .listTableDetailsDescSub {
  display: table-cell;
  vertical-align: middle;
  padding: 0 5px 0 10px;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc .titleActions {
  display: table-cell;
  vertical-align: middle;
  text-align: right;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc .listTableDetailsDescSub .listTableDetailsDescName {
  font-size: 12px;
  font-weight: normal;
  /* color: #26344a; */
  margin: 0;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc .listTableDetailsDescSub .listTableDetailsDescValue {
  font-size: 16px;
  font-weight: 500;
  /* color: #26344a; */
  padding-top: 5px;
  margin: 0;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc.largeImg .listTableBigImgConytainer {
  width: 40px;
  height: 40px;
  display: table-cell;
  vertical-align: middle;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc.mediumImg .listTableBigImgConytainer {
  width: 30px;
  height: 30px;
  display: table-cell;
  vertical-align: middle;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc.smallImg .listTableBigImgConytainer {
  width: 20px;
  height: 20px;
  display: table-cell;
  vertical-align: middle;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc .listTableBigImgConytainer img {
  max-width: 100%;
  width: 100%;
  height: 100%;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainerDivRepet .seeMoreFooter {
  padding: 0 15px;
  text-align: center;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainerDivRepet .seeMoreFooter .seeMoreLink {
  cursor: pointer;
  color: var(--sdk-chat-widow-primary-blue-color);
  font-size: 14px;
  font-weight: normal;
  border-top: 1px solid var(--sdk-chat-widow-primary-border-color);
  padding: 15px 0;
  display: block;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainerDivRepet .listTableDetails .listTableHeader {
  margin: 0 0 15px 0;
  font-size: 14px;
  font-weight: bold;
  padding: 10px;
  color: var(--sdk-chat-widow-primary-font-color);
  display: block;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainerDivRepet .listTableDetails .listTableHeader .listTableHeaderDesc .headerDesc {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainerDivRepet .listTableDetails .listTableDetailsDescName.pointer:hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/tableListTemplate/tableListTemplate.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;AACJ;;AACA;EACI,qDAAA;EACA,iDAAA;EACA,mBAAA;AAEJ;;AACA;EACI,WAAA;AAEJ;;AACA;EACI,eAAA;EACA,iBAAA;EACA,+CAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;AAEJ;;AAAA;EACI,YAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;AAGJ;;AADA;EACI,WAAA;EACA,eAAA;EACA,qBAAA;AAIJ;;AAFA;EACI,WAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;AAKJ;;AAHA;EACI,eAAA;AAMJ;;AAJA;EACI,mEAAA;EACC,eAAA;EACA,qBAAA;EACA,WAAA;AAOL;;AALA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAQF;;AANA;EACI,gBAAA;AASJ;;AAPA;EACI,WAAA;EACA,WAAA;EACA,mBAAA;AAUJ;;AARA;EACI,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,+CAAA;EACA,UAAA;EACA,qBAAA;AAWJ;;AATA;EACI,qBAAA;EACA,mBAAA;AAYJ;;AAVA;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,+CAAA;EACA,kEAAA;EACA,cAAA;EACA,WAAA;AAaJ;;AAXA;EACI,eAAA;AAcJ;;AAZA;EACI,mBAAA;EACA,aAAA;AAeJ;;AAbA;EACI,mBAAA;EACA,aAAA;AAgBJ;;AAdA;EACI,mBAAA;EACC,aAAA;AAiBL;;AAfA;EACI,0BAAA;EACA,eAAA;EACA,qBAAA;AAkBJ;;AAfA;EACI,gBAAA;EACA,gBAAA;AAkBJ;;AAhBA;EACI,mBAAA;EACA,sBAAA;EACA,qBAAA;AAmBJ;;AAjBA;EACI,mBAAA;EACA,sBAAA;EACA,iBAAA;AAoBJ;;AAlBA;EACI,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;AAqBJ;;AAnBA;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,SAAA;AAsBJ;;AAnBA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AAsBJ;;AApBA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AAuBJ;;AArBA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AAwBJ;;AAtBA;EACI,eAAA;EACA,WAAA;EACA,YAAA;AAyBJ;;AAvBA;EACI,eAAA;EACA,kBAAA;AA0BJ;;AAxBA;EACI,eAAA;EACA,+CAAA;EACA,eAAA;EACA,mBAAA;EACA,gEAAA;EACA,eAAA;EACA,cAAA;AA2BJ;;AAzBA;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,+CAAA;EACA,cAAA;AA4BJ;;AAxBA;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;AA2BJ;;AAzBA;EACG,eAAA;AA4BH","sourcesContent":[".kore-chat-window .kore-chat-body .dummy.listTableContainerDiv{\n    pointer-events: none;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv{\n    background-color: var(--sdk-chat-widow-default-white);\n    box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);\n    border-radius: 10px;  \n}\n\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainerDivRepet{\n    width: 100%;\n}\n\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableHeader .listTableHeaderTitle{\n    font-size: 16px;\n    font-weight: bold;\n    color: var(--sdk-chat-widow-primary-font-color);\n    width: 100%;\n    display: block;\n    float: left;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableHeader .listtableHeaderFilters{\n    width: 120px;\n    display: block;\n    float: left;\n    text-align: right;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableHeader .listtableHeaderFilters .filterIcon{\n    width: 15px;\n    cursor: pointer;\n    display: inline-block;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableHeader .listtableHeaderFilters .sortingIcon{\n    width: 15px;\n    cursor: pointer;\n    display: inline-block;\n    margin-left: 20px;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer{\n    padding: 0 15px;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv{\n    border-bottom: 1px solid var(--sdk-chat-widow-primary-border-color);\n     padding: 15px 0;\n     display: inline-block;\n     width: 100%;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc .titleActions .listViewItemValue{\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv:nth-last-child(1){\n    border-bottom: 0;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails{\n    float: left;\n    width: 100%;\n    vertical-align: top;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsTitle{\n    /* margin: 0 0 15px 0; */\n    font-size: 14px;\n    font-weight: bold;\n    color: var(--sdk-chat-widow-primary-font-color);\n    width: 58%;\n    display: inline-block;  \n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainerDivRepet .listTableDetails .listTableHeader .listTableHeaderDesc{  \n    display: inline-block;\n    vertical-align: top;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc{\n    margin: 0 0 15px 0;\n    font-size: 14px;\n    font-weight: bold;  \n    padding:10px;\n    color: var(--sdk-chat-widow-primary-font-color);\n    border-bottom: 1px solid var(--sdk-chat-window-table-border-color);\n    display: table;\n    width: 100%;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc.pointerStyle:hover{\n    cursor:pointer;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc.largeImg{    \n    margin-bottom: 10px;\n    padding: 10px;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc.mediumImg{   \n    margin-bottom: 10px;\n    padding: 10px;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc.smallImg{  \n    margin-bottom: 10px;\n     padding: 10px;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listViewItemValue.actionLink.actiontitle{\n    text-decoration: underline;\n    cursor: pointer;\n    display:inline-block;\n}\n\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc:nth-last-child(1){\n    margin-bottom: 0;\n    border-bottom: 0;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc .listTableDetailsDescSub {\n    display: table-cell;\n    vertical-align: middle;\n    padding: 0 5px 0 10px;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc .titleActions{\n    display: table-cell;\n    vertical-align: middle;\n    text-align: right;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc .listTableDetailsDescSub .listTableDetailsDescName{\n    font-size: 12px;\n    font-weight: normal;\n    /* color: #26344a; */\n    margin: 0\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc .listTableDetailsDescSub .listTableDetailsDescValue{\n    font-size: 16px;\n    font-weight: 500;\n    /* color: #26344a; */\n    padding-top: 5px;\n    margin: 0;\n}\n\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc.largeImg .listTableBigImgConytainer{\n    width: 40px;\n    height: 40px;\n    display: table-cell;\n    vertical-align: middle;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc.mediumImg .listTableBigImgConytainer{\n    width: 30px;\n    height: 30px;\n    display: table-cell;\n    vertical-align: middle;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc.smallImg .listTableBigImgConytainer{\n    width: 20px;\n    height: 20px;    \n    display: table-cell;\n    vertical-align: middle;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainer .listTableDetailsBorderDiv .listTableDetails .listTableDetailsDesc .listTableBigImgConytainer img{ \n    max-width: 100%;\n    width: 100%;\n    height: 100%;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainerDivRepet .seeMoreFooter{\n    padding: 0 15px;\n    text-align: center;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainerDivRepet .seeMoreFooter .seeMoreLink{\n    cursor: pointer;\n    color: var(--sdk-chat-widow-primary-blue-color);\n    font-size: 14px;\n    font-weight: normal;  \n    border-top: 1px solid var(--sdk-chat-widow-primary-border-color);\n    padding: 15px 0;\n    display: block;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainerDivRepet .listTableDetails .listTableHeader{\n    margin: 0 0 15px 0;\n    font-size: 14px;\n    font-weight: bold;    \n    padding:10px;\n    color: var(--sdk-chat-widow-primary-font-color);\n    display: block;\n}\n\n\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainerDivRepet .listTableDetails .listTableHeader .listTableHeaderDesc .headerDesc{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.kore-chat-window .kore-chat-body .listTableContainerDiv .listTableContainerDivRepet .listTableDetails .listTableDetailsDescName.pointer:hover{\n   cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
